import React from 'react';
import classNames from 'classnames';
import { inject, observer } from 'mobx-react';

import styles from '../bannerModule.scss';
import IconArrowExtraSmallRight from '../../icons/icon_arrow_extra_small_right';
import DataStore from '../../../stores/DataStore';
import LogoService from '../../icons/logoservice';
import TabNavigationHelper from '../../../helper/tabNavigationHelper';

const LogoServiceBanner = inject('dataStore')(
    observer((props: { dataStore?: DataStore }) => {
        const tabNavigation = TabNavigationHelper.instance;
        const { dataStore } = props;
        const logoServiceRedirectUrl = dataStore?.bannerModule.logoServiceRedirectUrl;
        const isSmakeDesignerAvailable =
                dataStore?.shutterModule.productInfo?.description?.isSmakeDesignerAvailable ?? false;
        const logoCreatorEnabled = dataStore?.contextData.featureToggles.enableLogoCreator ?? false;

        if (!dataStore || (!logoServiceRedirectUrl && !isSmakeDesignerAvailable)) {
            return null;
        }

        const handleLogoServiceBannerClick = () => {
            if (logoCreatorEnabled && isSmakeDesignerAvailable) {
                if (logoServiceRedirectUrl) {
                    dataStore.mainStore?.showPersonalizeOverlay();
                } else {
                    dataStore.mainStore?.onPersonalizeIntent();
                }

                return;
            }

            if (logoServiceRedirectUrl) {
                window.open(logoServiceRedirectUrl, '_self');
            }
        };

        function getHeaderTitle(): string | undefined {
            if (!dataStore) {
                return '';
            }

            return logoCreatorEnabled && isSmakeDesignerAvailable ?
                dataStore.mainStore.localization.logoCreatorL10n?.personalise : 
                dataStore.mainStore.localization.generalL10n.logoService;
        }

        return (
            <div
                data-testid='logo_service_banner'
                data-semantic-id='logo_service_banner'
                className={styles.banner_item}
                onClick={handleLogoServiceBannerClick}
                ref={(el) => tabNavigation.setFocusAtt(el)}
            >
                <div className={styles.header}>
                    <LogoService />
                    <p className={styles.header_banner_type}>
                        {getHeaderTitle()}
                    </p>
                </div>
                <div
                    className={classNames(styles.media_content, styles.media_content_logo_service)} 
                    title={getHeaderTitle()}
                />
                <div
                    data-testid='logo_service_button'
                    data-semantic-id='logo_service_button'
                    className={styles.footer}
                >
                    <div className={styles.button}>
                        <div className={styles.title}>
                            {dataStore.mainStore.localization.generalL10n.discoverNow}
                        </div>
                        <IconArrowExtraSmallRight />
                    </div>
                </div>
            </div>
        );
    })
);

export default LogoServiceBanner;
